<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.userId" placeholder="请输入被举报人ID" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="不限制状态" value=""></el-option>
                        <el-option label="仅看待处理的" :value="1"></el-option>
                        <el-option label="仅看已处理的" :value="2"></el-option>
                        <el-option label="仅看已忽略的" :value="3"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="被举报时间" :value="1"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            align="right"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="isHandle" label="状态" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.isHandle==3">已忽略</span>
                        <span v-else-if="scope.row.isHandle==2" class="color-success">已处理</span>
                        <span v-else-if="scope.row.isHandle==1" class="color-danger">待处理</span>
                    </template>
                </el-table-column>
                <el-table-column prop="content" label="内容" min-width="200" show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="图片">
                    <template slot-scope="scope">
                        <el-image v-if="scope.row.pic && scope.row.pic.length == 1" :src="scope.row.pic[0] | coverImage(120,120)" fit="cover" :preview-src-list="[scope.row.pic[0]]"></el-image>
                        <el-button v-else-if="scope.row.pic && scope.row.pic.length > 1" type="text" size="mini" @click="preiewImg(scope.row.pic)">多图</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="mainId" label="被举报人ID"></el-table-column>
                <el-table-column prop="name" label="被举报人姓名" show-overflow-tooltip></el-table-column>
                <el-table-column prop="reportType" label="被举报类型">
                    <template slot-scope="scope">
                        {{reportType.get(scope.row.reportType)}}
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="被举报时间" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/report/detail')"
                            type="text"
                            size="small"
                            icon="el-icon-s-management"
                            @click="edit(scope.row.id)"
                            >管理</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>

        <el-dialog :visible.sync="photoListView" title="举报图片" center append-to-body>
            <div class="preview-box">
                <el-image style="width: 100px; height: 100px;margin: 10px;" v-for="(image, index) in photoList" fit="cover" :src="image | coverImage(200,200)" :preview-src-list="photoList.slice(index).concat(photoList.slice(0,index))" :key="index">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
            </div>
        </el-dialog>

    </div>
</template>

<script>
const defaultParams = {
    pageNo:1,
    userId:"",
    status: 1,
    startTime:'',
    endTime:'',
    timeType: 1
}
export default {
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                userId: this.$route.query.userId || '',
                status: parseInt(this.$route.query.status || 1),
                startTime: this.$route.query.startTime || '',
                endTime: this.$route.query.endTime || '',
            },
            listLoading: true,
            datetimerange:[this.$route.query.startTime || '' , this.$route.query.endTime || ''],

            photoList: [],
            photoListView: false,
        }
    },
    computed:{
        reportType(){
            return new Map([
                [1,'欺诈'],[2,'色情'],[3,'广告'],[4,'骚扰'],[5,'其它'],[10,'动态'],[11,'评论'],[12,'回复'],[14,'弹幕']
            ])
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.params = {
                ...this.params,
                startTime:this.datetimerange && this.datetimerange[0] || '',
                endTime:this.datetimerange && this.datetimerange[1] || ''
            }
            this.listLoading = true;
            this.$request({
                url: "/report/list",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
                    this.dataList.map( v => {
                        v.pic = v.pic ? v.pic.split(',') : ''
                    })
				} else {
                    this.data = null;
					this.dataList = [];
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //编辑
        edit(id){
            this.$router.push({
                path: `/operation/accusation/edit/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        {
                            ...this.params,
                        }
                    ),
                },
            });
        },
        preiewImg(list){
            this.photoList = list;
            this.photoListView = true;
        }
    }
}
</script>